import React from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import LeaguesStatsByStatus from '../components/LeaguesStatsByStatus';
import AverageDurationLeagues from '../components/AverageDurationLeagues';
import AverageLeaguesByUser from '../components/AverageLeaguesByUser';
import CreatedContests from '../components/CreatedContests';
import AverageLeaguesSize from '../components/AverageLeaguesSize';

const MPPStatsLeagues = () => (
  <div id="league-MPP">
    <header className="content-header">
      <h1>
        Statistics
        <small>Leagues</small>
      </h1>
      <ol className="breadcrumb">
        <li>
          <i className="fa fa-bar-chart" /> Statistics
        </li>
        <li className="text-bold">
          <Link to="/mpp/stats/challenges">Leagues</Link>
        </li>
      </ol>
    </header>
    <section className="content">
      <div className="row">
        <div className="col-lg-6">
          <CreatedContests />
          <AverageLeaguesSize />
        </div>
        <div className="col-lg-6">
          <AverageLeaguesByUser />
          <AverageDurationLeagues />
          <LeaguesStatsByStatus />
        </div>
      </div>
    </section>
  </div>
);

export default connect(
  state => ({}),
  dispatch => ({dispatch}),
)(MPPStatsLeagues);



// WEBPACK FOOTER //
// ./src/pages/Other/MPP/Stats/Leagues/index.tsx